import { useRedux } from "hooks"
import { useEffect, useMemo, useState } from "react";
import { loadDllEmployee } from "../redux/workplace/wpActions";
import { TaskStatus, WpSliceData } from "../redux/workplace/wpTypes";
import { createSelector } from "reselect";
import Select, { components, OptionProps, SingleValueProps, DropdownIndicatorProps, IndicatorSeparatorProps } from 'react-select';
import { Utils } from "helpers/utils";
import SelectDropdown from "./SelectDropdown";
import { APIClient } from "api/apiCore";
import * as urls from "../api/urls";
import AsyncSelect from "react-select/async";
import type { OptionsOrGroups, GroupBase } from "react-select";
import { debounce } from "lodash";
import { DropdownOption } from "types";


interface SelectDropdownAsyncWpTagsProps {
  // onStatusChanged: (status: TaskStatus | null) => void;
  // selectedStatus?: TaskStatus | null;
  // isDisabled: boolean;
  selectedValues: DropdownOption[];
  onValueChanged?: (values: DropdownOption[]) => void;
}

const SelectDropdownAsyncWpTags = ({ selectedValues, onValueChanged }: SelectDropdownAsyncWpTagsProps) => {

  // const [value, setValue] = useState<DropdownOption[]>([]);

  const debouncedLoad = useMemo(
    () =>
      debounce(
        async (
          inputValue: string,
          callback: (options: OptionsOrGroups<DropdownOption, GroupBase<DropdownOption>>) => void
        ) => {
          if (!inputValue) {
            callback([]);
            return;
          }

          const api = new APIClient();
          const data = await api.fnPostForm(
            urls.WP_FIND_TAG_FOR_RECURANCE,
            { keywords: inputValue }
          );

          const rs: DropdownOption[] = data.map((x: any) => ({
            value: x.tagId,
            label: `${x.categoryName} : ${x.tagName}`,
          }));

          callback(rs);
        },
        300
      ),
    []
  );

  const loadOptions = (
    inputValue: string,
    callback: (options: OptionsOrGroups<DropdownOption, GroupBase<DropdownOption>>) => void
  ) => {
    debouncedLoad(inputValue, callback);
  };

  useEffect(() => {
    return () => {
      debouncedLoad.cancel();
    };
  }, [debouncedLoad]);

  return (
    <AsyncSelect
      isMulti
      cacheOptions
      styles={Utils.GetThemeForReactSelect()}
      defaultOptions={false}
      loadOptions={loadOptions}
      value={selectedValues}
      onChange={(v) => onValueChanged?.(v as DropdownOption[])}
      placeholder="พิมพ์เพื่อหา..."
    />
  )
}

export default SelectDropdownAsyncWpTags

